// NOTE: This file uses the Firebase Compatibility libraries to provide
// backwards compatibility with prior versions of Firebase. New code should
// use `firebase.js` instead. Once the application code is updated to use the
// new style APIs, this code can be removed.

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";

import { firebaseConfig, shouldUseEmulator } from "../config";

firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
export const auth = firebase.auth() ;

if (shouldUseEmulator) {
  console.log("Using Firebase emulator for compatibility libs.");
  db.useEmulator("localhost", 8080);
  auth.useEmulator("http://localhost:9099");
}
